import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

export const IS_POSTCODE_MATCHING_FOR_SUBCATEGORY = gql`
  query IsPostcodeMatchingForSubcategory(
    $subcategoryId: String!
    $postcode: String!
  ) {
    isPostcodeMatchingForSubcategory(
      subcategoryId: $subcategoryId
      postcode: $postcode
    ) {
      isMatching
    }
  }
`;

/**
 * Apollo request
 */
const isPostcodeMatchingForSubcategoryQuery = async (variables) => {
  try {
    const { data } = await query({
      query: IS_POSTCODE_MATCHING_FOR_SUBCATEGORY,
      variables,
    });
    return data.isPostcodeMatchingForSubcategory.isMatching;
  } catch (error) {
    throw new Error('Failed to determine if zip code is matching', error);
  }
};

export default isPostcodeMatchingForSubcategoryQuery;
